import React, { useState } from 'react'
import { Col, Form, Row, Collapse } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { ArrowBigIcon } from '../Icons/ArrowBigIcon'
import { StyledCollapseTrigger } from '../Configuration/Articles/formHelper'
import { colors } from '../../styles/colors'

const ScanCodeData = ({ scanCodeObj, setScanCodeObj, currentJobObj, editable, disableComment = true, disableCollapse = true }) => {
    const { t } = useTranslation()
    const [scanInfoIsOpen, setScanInfoIsOpen] = useState(false)
    const renderDetails = () => {
        return (
            <>
                <StyledCollapseTrigger
                    onClick={() => setScanInfoIsOpen((prev) => !prev)}
                >
                    <h2 className='h2'>
                        <ArrowBigIcon
                            variant={scanInfoIsOpen ? 'down' : 'right'}
                            color={colors.textColor}
                        />
                        {'Details'}
                    </h2>
                </StyledCollapseTrigger>
                <Collapse in={scanInfoIsOpen}>
                    <div>
                        {renderScanInfo()}
                    </div>
                </Collapse>
            </>
        )
    }
    const renderScanInfo = () => {
        return (
            <Row className='mb-3'>
                <Form.Group as={Row}>
                    <Form.Label column>{t('washPage:bearer')}:</Form.Label>
                    <Col>
                        <div>{scanCodeObj?.businesspartner?.displayName}</div>
                    </Col>
                </Form.Group>
                <Form.Group as={Row}>
                    <Form.Label column>{t('orgaUnit')}:</Form.Label>
                    <Col>
                        <div>{scanCodeObj?.office?.displayName}</div>
                    </Col>
                </Form.Group>
                <Form.Group as={Row}>
                    <Form.Label column>{t('costcenter')}:</Form.Label>
                    <Col>
                        <div>{scanCodeObj?.costcenter?.displayName}</div>
                    </Col>
                </Form.Group>
                <Form.Group as={Row}>
                    <Form.Label column>{t('localInventoriesTable:articleName')}:</Form.Label>
                    <Col>
                        <div>{scanCodeObj?.article?.displayName}{scanCodeObj?.article?.articleNumber && ` (${scanCodeObj?.article?.articleNumber})`}</div>
                    </Col>
                </Form.Group>
                <Form.Group as={Row}>
                    <Form.Label column>{t('localInventoriesTable:sizeName')}:</Form.Label>
                    <Col>
                        <div>{scanCodeObj?.articleVariant?.displayName}</div>
                    </Col>
                </Form.Group>
            </Row>
        )
    }
    return (
        <div>
            <Row className='mb-3'>
                <Form.Group as={Row}>
                    <Form.Label column>{t('inventory:scanCode')}:</Form.Label>
                    <Col>
                        <div>{scanCodeObj?.rfid}</div>
                    </Col>
                </Form.Group>
            </Row>
            {currentJobObj?.comment && <Row className='mb-3'>
                <Form.Group as={Row}>
                    <Form.Label column>{t('description')}:</Form.Label>
                    <Col>
                        <div>{currentJobObj?.comment}</div>
                    </Col>
                </Form.Group>
            </Row>}
            {!disableCollapse ? <Row className='mb-3'>{renderDetails()}</Row> : renderScanInfo()}
            <Row className='mb-3'>
                <Form.Group as={Row}>
                    <Form.Label column>{t('inventory:washProcess')}:</Form.Label>
                    <Col>
                        <div>{scanCodeObj?.washCounter}</div>
                    </Col>
                </Form.Group>
                {!!scanCodeObj?.washCycles &&
                    <>
                        <Form.Group as={Row}>
                            <Form.Label column>{t('inventory:washCycles')}:</Form.Label>
                            <Col>
                                <div>{scanCodeObj?.washCycles}</div>
                            </Col>
                        </Form.Group>
                        {!editable ? null :
                            <Form.Group as={Row}>
                                <Form.Label column>{t('washPage:washCountAdd')}:</Form.Label>
                                <Col>
                                    <Form.Control
                                        id='addCycles'
                                        name='addCycles'
                                        placeholder=''
                                        value={scanCodeObj?.additionalWashCycles ?? 0}
                                        onChange={(e) => setScanCodeObj((prev) => ({
                                            ...prev,
                                            additionalWashCycles: parseInt(e.target.value) || 0
                                        }))}
                                        autoFocus
                                    />
                                </Col>
                            </Form.Group>}
                    </>
                }
                {!disableComment && <Form.Group as={Row}>
                    <Form.Label column>{t('comment')}:</Form.Label>
                    <Col>
                        <Form.Control
                            as='textarea'
                            placeholder={t('comment')}
                            name='comment'
                            value={scanCodeObj?.comment ?? ''}
                            onChange={(e) => setScanCodeObj((prev) => ({
                                ...prev,
                                comment: e.target.value
                            }))}
                        />
                    </Col>
                </Form.Group>}
            </Row>
        </div>
    )
}

export default ScanCodeData
